/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Tracker_Trackedprefix1Inputs */

const he_extension_tracker_trackedprefix1 = /** @type {(inputs: Extension_Tracker_Trackedprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`במעקב ב-PriceDrop`)
};

const en_extension_tracker_trackedprefix1 = /** @type {(inputs: Extension_Tracker_Trackedprefix1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracked on PriceDrop`)
};

/**
* | output |
* | --- |
* | "Tracked on PriceDrop" |
*
* @param {Extension_Tracker_Trackedprefix1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_tracker_trackedprefix1 = /** @type {((inputs?: Extension_Tracker_Trackedprefix1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Tracker_Trackedprefix1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_tracker_trackedprefix1(inputs)
	return en_extension_tracker_trackedprefix1(inputs)
});
export { extension_tracker_trackedprefix1 as "extension_tracker_trackedPrefix" }